import React from "react";
import Headerdash from "../head";
import Sidebar from "../sidebar";
import { useNavigate } from "react-router-dom";
import AudioPlayer from "../QuestionPage/AudioPlayer";

import { useState, useEffect } from "react";
import MockPagination from "./Pagination";
import MockNavigation from "./MockNavigation";

// Fetching Data from the API]

// End

// Page Html
export default function HeadphoneCheckPage() {
  // End
  const navigate = useNavigate();
  const [audioLink, setaudioLink] = useState("");


  const handleButtonClick = () => {
    navigate("/");
  };

  useEffect(() => {
    const fetchSignedUrl = async () => {
      try {
        const res = await fetch("/ptedata/ptemedia/001_1585917752.mp3");
        const data = await res.json(); // expecting { url: "https://..." }
        setaudioLink(data.url);
      } catch (err) {
        console.error("Failed to fetch audio URL", err);
      }
    };

    fetchSignedUrl();
  }, []);


  return (
    <div>
      <div className="relative top-10 bg-gray-100 max-w-full py-5 px-5 md:px-10 mx-4 rounded-sm border border-t-2">
        <div className="max-w-full bg-blue-500 h-3"></div>
        <h1 className="text-2xl pt-3 font-bold text-gray-900 sm:text-3xl ml-1 text-center md:text-start">
          Headset Check
        </h1>
        <p className="p-2">
        This is an opportunity to check that your headset is working correctly

          <br></br>
          <span>1. Put your headset on and adjust it so that if it's comfortably over your ears</span>
          <br></br>
          <span>2. When you are ready. cilck on the play button. You hear a short recording</span>
          <br></br>
          <span>3. If you do not hear anything in your headphones while the status reads Playing. Raise your hard to get the alteration of the Test Administator </span>
        </p>
        <img
          className=" absolute  top-12 right-12"
          width="200px"
          src="/image/headphones.jpg"
        ></img>
        <AudioPlayer audioSrc={audioLink} />
        <ul className="p-6">
          <li className=" list-disc pl-4">
          During the test you will not have Play and Stop buttons. The audio recording will start playing automatically          </li>
          <li className=" list-disc pl-4">Please do not remove your headset. You should wear it throughtout the test.</li>
        </ul>
      </div>
    </div>
  );
}
